import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VBtn,{staticClass:"float-right",class:_vm.buttonClass,attrs:{"disabled":!_vm.valid || _vm.disabled || _vm.loading,"color":"success","loading":_vm.loading,"depressed":""},on:{"click":_vm.onClick}},[(_vm.isToAddNewItem())?_c(VIcon,{staticClass:"mr-2"},[_vm._v(" "+_vm._s(_vm.buttonIcon())+" ")]):_vm._e(),_vm._v(" "+_vm._s(_vm.label || _vm.buttonMessage())+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }